module.exports = __webpack_public_path__ + "static/img/1000020icon.b98bcdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1000020icon.png
// module id = R8Cm
// module chunks = 1